function normalizeMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  if (typeof err === "string") return err;
  return String(err);
}

function getHttpStatus(err: unknown): number | undefined {
  if (typeof err !== "object" || err === null) return undefined;
  const o = err as Record<string, unknown>;
  if (typeof o.status === "number" && Number.isFinite(o.status)) {
    return o.status;
  }
  return undefined;
}

function isLikelyNetworkError(lower: string): boolean {
  return (
    lower.includes("failed to fetch") ||
    lower.includes("networkerror") ||
    lower.includes("network error") ||
    lower.includes("network request failed") ||
    lower.includes("load failed") ||
    lower.includes("ecconnrefused") ||
    lower.includes("econnreset")
  );
}

function matchesIgnoredAuthUserMessage(lower: string): boolean {
  if (
    lower.includes("invalid login credentials") ||
    lower.includes("invalid email") ||
    lower.includes("email not confirmed") ||
    lower.includes("not confirmed") ||
    (lower.includes("confirm") && lower.includes("email"))
  ) {
    return true;
  }

  if (
    lower.includes("user already registered") ||
    lower.includes("already registered") ||
    lower.includes("already exists")
  ) {
    return true;
  }

  if (
    lower.includes("password should be at least") ||
    lower.includes("password must be at least")
  ) {
    return true;
  }

  if (
    lower.includes("rate limit") ||
    lower.includes("over_email_send_rate_limit") ||
    lower.includes("too many requests")
  ) {
    return true;
  }

  if (
    lower.includes("zod") ||
    lower.includes("validation error") ||
    lower.includes("react hook form") ||
    lower.includes("hook form")
  ) {
    return true;
  }

  return false;
}

/** True when the error should be reported to Sentry (genuine/system issues). */
export function shouldReportAuthFlowExceptionToSentry(err: unknown): boolean {
  const status = getHttpStatus(err);
  if (status !== undefined && status >= 500) {
    return true;
  }

  const message = normalizeMessage(err);
  const lower = message.toLowerCase();

  if (isLikelyNetworkError(lower)) {
    return true;
  }

  if (matchesIgnoredAuthUserMessage(lower)) {
    return false;
  }

  return true;
}
